// extracted by mini-css-extract-plugin
module.exports = {"headingTitle":"internal-screen_headingTitle__XRidC"};